import cn from 'classnames'

import './styles.scss'

interface Props {
  period: string
  cost: string
  label: string
  className?: string
}

export const PayVariant = ({ period, cost, label, className }: Props) => {
  return (
    <div className={cn('pay-variant', className)}>
      <span className="cost">{cost}</span>
      <span className="period">/{period}</span>
      <div className="label">{label}</div>
    </div>
  )
}
